export const customersConstants = {
  UPDATE_CUSTOMER: '[Customers] Update',
  REMOVE_CUSTOMER: '[Customers] Remove',
  LOADING_CUSTOMERS: '[Customers] Loading',
  LOADING_CUSTOMERS_ERROR: '[Customers] Loading error',
  CUSTOMER_AJAX_CALL: '[Customers] Ajax call',
  CUSTOMER_AJAX_SUCCESS: '[Customers] Ajax success',
  CUSTOMER_AJAX_FAILURE: '[Customers] Ajax error'
}
